/* eslint-disable react/no-array-index-key */
import { Font, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { FC, Fragment } from 'react';
import getTailwindConfig from '../../../helpers/get-tailwind-config';
import { DiscountStructureItemType } from '../../../models/discount-structure-item-type';
import { DiscountStructureType } from '../../../models/discount-structure-type';
import { UserType } from '../../../models/user-type';
import PdfLayout from '../pdf-layout/pdf-layout';

const styles = StyleSheet.create({
  bold: {
    fontFamily: 'Inter-Bold',
  },
  table: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    display: 'table' as any,
    tableLayout: 'fixed',
    width: '100%',
  },
  tableRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tableData: {
    fontSize: 10,
    paddingHorizontal: 5,
    paddingVertical: 8,
    width: 'calc(100% / 12)',
  },
});

Font.register({ family: 'Inter-Bold', src: '/fonts/Inter/Inter-Bold.ttf' });

interface Props extends DiscountStructureType {
  readonly discountsGroups: DiscountStructureItemType[][];
  readonly user: UserType;
}

const DiscountStructurePdf: FC<Props> = ({
  address,
  discountsGroups,
  emailAddress,
  faxNumber,
  labels: {
    accountNumberFieldLabel,
    dateFieldLabel,
    emailFieldLabel,
    faxNumberFieldLabel,
    groupColumnLabel,
    pageNumberLabel,
    percentageColumnLabel,
    telephoneNumberFieldLabel,
    title,
    websiteFieldLabel,
  },
  telephoneNumber,
  user,
  websiteAddress,
  websiteLogo,
}: Props) => {
  const { colors } = getTailwindConfig().theme;

  return (
    <PdfLayout
      address={address}
      emailAddress={emailAddress}
      faxNumber={faxNumber}
      labels={{
        accountNumberFieldLabel,
        dateFieldLabel,
        emailFieldLabel,
        faxNumberFieldLabel,
        pageNumberLabel,
        telephoneNumberFieldLabel,
        title,
        websiteFieldLabel,
      }}
      telephoneNumber={telephoneNumber}
      user={user}
      websiteAddress={websiteAddress}
      websiteLogo={websiteLogo}
    >
      <View style={styles.table}>
        <View
          fixed
          style={[styles.tableRow, { borderBottom: '2px solid black' }]}
        >
          {new Array(6).fill(null).map((value: null, index: number) => (
            <Fragment key={`heading-${index}`}>
              <View style={[styles.tableData, styles.bold]}>
                <Text>{groupColumnLabel}</Text>
              </View>

              <View style={[styles.tableData, { textAlign: 'center' }]}>
                <Text>{percentageColumnLabel}</Text>
              </View>
            </Fragment>
          ))}
        </View>

        {discountsGroups[0].map((discountGroup, index: number) => (
          <View
            key={`row-${index}`}
            style={[
              styles.tableRow,
              {
                borderBottom: `1px solid ${colors.grey['100']}`,
                borderLeft: `1px solid ${colors.grey['100']}`,
              },
            ]}
            wrap={false}
          >
            {discountsGroups.map(
              (group: DiscountStructureItemType[], dataIndex: number) => (
                <Fragment key={`data-${dataIndex}`}>
                  <View
                    style={[
                      styles.tableData,
                      { color: colors['french-blue'].DEFAULT },
                    ]}
                  >
                    <Text>{group[index]?.group}</Text>
                  </View>

                  <View
                    style={[
                      styles.tableData,
                      {
                        borderRight: `1px solid ${colors.grey['100']}`,
                        textAlign: 'center',
                      },
                    ]}
                  >
                    <Text>{group[index]?.percentage}</Text>
                  </View>
                </Fragment>
              )
            )}
          </View>
        ))}
      </View>
    </PdfLayout>
  );
};

export default DiscountStructurePdf;
